export default __webpack_public_path__ + "static/media/icons-addToList-second.6113ca6b.svg";